const scrollTopInit = () => {
  const scrollTopBtn = document.querySelector('.footer__gotop_link');
  scrollTopBtn.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  });
};

export default scrollTopInit;
